module.exports = "/fonts/opensanssemibolditalic.woff";